<template>
  <nav class="navbar">
    <img src="../assets/logo.png" alt="" class="img-logo">
    <div class="itemNav">
      <ul class="navbarNav">
        <li>
          <router-link class="nav-link" to="/">Home</router-link>
        </li>
        <li>
          <router-link class="nav-link" to="/event">Event</router-link>
        </li>
        <li>
          <router-link class="nav-link" to="/service">Service</router-link>
        </li>
        <li>
          <router-link class="nav-link" to="/showcase">Showcase</router-link>
        </li>
        <li>
          <router-link class="nav-link" to="/blog">Blog</router-link>
        </li>
        <li>
          <router-link class="nav-link" to="/about">About Us</router-link>
        </li>
      </ul>
    </div>

    <div class="btn-nav">
      <router-link :to="{name: 'DetailEvent'}">
        <button class="btn-login">Login</button>
      </router-link>
      <router-link :to="{name: 'DetailEvent'}">
        <button class="btn-register">Register Now</button>
      </router-link>
    </div>
    <div class="hamburger-menu" @click="menu()">
      <img src="../assets/menu.svg" alt="">
    </div>
  </nav>
</template>

<script>
export default {
  name: `NavbarComp`,
  methods: {
    menu() {
      document.querySelector('ul').classList.toggle('active-nav')
    }
  }
};
// const menu = () => {
//   return console.log('hello world')
// }
</script>

<style>
#app {
  font-family: "Poppins", sans-serif;
}
.navbar {
  margin-left: 6%;
  margin-top: 1%;
}
.navbarNav {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: 0;
  text-decoration: unset;
  list-style-type: none;
}
.img-logo {
  width: 168px;
  height: 34px;
}
.nav-link {
  font-size: 16px;
  color: #023047;
  font-weight: 400;
  margin-top: 20px;
  margin-left: 30px;
}
.nav-link:hover {
  font-weight: 500;
}
.btn-register {
  width: 139px;
  height: 42px;
  border-radius: 100px;
  background-color: #023047;
  color: white;
  font-size: 12px;
  margin-left: 13px;
}
.btn-register:hover {
  background-color: white;
  color: #023047;
  outline-color: #023047;
}
.btn-login {
  width: 139px;
  height: 42px;
  border-radius: 100px;
  background-color: #f5f5f5;
  outline-color: #023047;
  font-size: 12px;
}
.btn-login:hover {
  background-color: #f74d00;
  border: #f74d00;
  color: #fff;
}
.hamburger-menu {
  display: none;
}
@media only screen and (max-width: 1210px) {
  .itemNav {
    flex: 1%;
  }
  .itemNav ul {
    padding-left: 0%;
  }
  .navbarNav {
    margin-left: 0%;
  }
  .btn-nav {
    margin-left: 0%;
  }
}
@media only screen and (max-width: 1180px) {
  .nav-link {
    margin-top: 17px;
  }
  .img-logo {
    width: 128px;
    height: 26px;
  }
}
@media only screen and (max-width: 1140px) {
  .nav-link {
    font-size: 14px;
    margin-left: 20px;
  }
}
@media only screen and (max-width: 1100px) {
  .img-logo {
    width: 108px;
    height: 22px;
  }
  .nav-link {
    margin-left: 15px;
  }
  .btn-login,
  .btn-register {
    width: 129px;
    height: 35px;
  }
}
@media only screen and (max-width: 1010px) {
  .navbar {
    margin-right: 0px;
    margin-bottom: -5%;
  }
  .img-logo {
    width: 100px;
    height: 20px;
  }
  .navbarNav {
    font-size: 14px;
    margin-left: 0%;
  }
  .nav-link {
    margin-left: 10px;
  }
  .btn-login {
    margin-left: 0%;
    width: 109px;
    height: 25px;
  }
  .btn-register {
    margin-left: 5px;
    width: 109px;
    height: 25px;
  }
}
@media only screen and (max-width: 820px) {
  .navbar {
    margin-right: 0px;
    padding: 20px 0;
  }
  .img-logo {
    width: 80px;
    height: 16px;
  }
  .navbarNav {
    font-size: 12px;
    margin-left: 10%;
    display: block;
    text-align: end;
    position: absolute;
    background-color: white;
    border-radius: 20px;
    padding: 1px 25px;
    box-sizing: border-box;
    max-width: 140px;
    width: 100%;
    right: 10px;
    top: 0px;
    display: none;
    transition: transform 1s;
  }
  .active-nav {
    display: block;
    top: 55px;
    z-index: 20;
  }
  .hamburger-menu {
    display: flex;
    align-items: center;
    display: block;
    position: absolute;
    right: 8px;
    cursor: pointer;
  }
  ul li .nav-link {
    margin-left: 10px;
    font-size: 15px;
    /* background: #000; */
  }
  .btn-login {
    margin-left: 0%;
    font-size: 11px;
    width: 90px;
    height: 25px;
  }
  .btn-register {
    margin-left: 5px;
    margin-right: 30px;
    font-size: 11px;
    width: 90px;
    height: 25px;
  }
}
@media only screen and (max-width: 720px) {
  .navbar {
    margin-left: 45px;
    margin-right: 0px;
    margin-bottom: -10%;
  }
  .img-logo {
    width: 70px;
    height: 14px;
  }
  .navbarNav {
    font-size: 10px;
    margin-left: 5%;
  }
  .nav-link {
    margin-left: 10px;
  }
  .btn-login {
    margin-left: 0%;
    font-size: 10px;
    width: 80px;
    height: 22px;
  }
  .btn-register {
    margin-left: 5px;
    margin-right: 0;
    font-size: 10px;
    width: 80px;
    height: 22px;
  }
  .btn-nav {
    position: relative;
    right: 40px;
  }
}
@media only screen and (max-width: 550px) {
  .navbar {
    margin-left: 25px;
    margin-right: 0px;
    margin-bottom: -15%;
  }
  .img-logo {
    width: 60px;
    height: 12px;
  }
  .navbarNav {
    font-size: 7.5px;
  }
  .nav-link {
    margin-left: 8px;
  }
  .btn-login {
    margin-left: 0%;
    font-size: 8px;
    width: 65px;
    height: 20px;
  }
  .btn-register {
    margin-left: 3px;
    font-size: 8px;
    width: 65px;
    height: 20px;
  }
}
@media only screen and (max-width: 450px) {
  .navbar {
    margin-left: 25px;
    margin-right: 0px;
    margin-bottom: -15%;
  }
  .img-logo {
    width: 55px;
    height: 11px;
  }
  .navbarNav {
    font-size: 5.5px;
  }
  .nav-link {
    margin-left: 4px;
  }
  .btn-nav {
    margin-top: -7px;
  }
  .btn-login {
    margin-left: 0%;
    font-size: 7px;
    width: 58px;
    height: 20px;
  }
  .btn-register {
    margin-left: 3px;
    font-size: 7px;
    width: 58px;
    height: 20px;
  }
}
@media only screen and (max-width: 350px) {
  .navbar {
    margin-left: 5%;
    margin-right: 0px;
    margin-bottom: -20%;
  }
  .img-logo {
    width: 50px;
    height: 10px;
  }
  .navbarNav {
    font-size: 4px;
    margin-left: 10%;
  }
  .nav-link {
    margin-left: 5px;
  }
  .btn-nav {
    margin-top: -7px;
  }
  .btn-login {
    margin-left: 0%;
    font-size: 5px;
    width: 45px;
    height: 20px;
  }
  .btn-register {
    margin-left: 3px;
    font-size: 5px;
    width: 45px;
    height: 20px;
  }
}
</style>